<template>
  <v-card>
    <v-card-title>
      <div>
        <h3 class="headline">{{labels.statistics}}</h3>
      </div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-sm v-if="quoteParam.statisticsInit === 1 && hasStats">
        <v-layout row wrap v-for="stats in statistics" :key="stats.key" align-center>
          <v-flex xs4>
            <v-subheader>{{getParamStat(stats.key).label}}*</v-subheader>
          </v-flex>
          <v-flex xs8>
            <v-select :items="getParamStat(stats.key).statsVal" v-model="stats.value" item-text="label" item-value="value" :data-vv-name="stats.key" :data-vv-as="getParamStat(stats.key).label" :error-messages="errors.collect(stats.key)" v-validate="'required'"></v-select>
          </v-flex>
        </v-layout>
      </v-container>
      <v-layout row wrap v-else-if="quoteParam.statisticsInit === 1 && !hasStats">
        <v-flex xs12>
          No Statistics found
        </v-flex>
      </v-layout>
      <loader v-else :card="false" :height="300" :init="doGetStats" loadText="Loading Statistics" errorText="Failed to load Statistics" :loading="quoteParam.statisticsInit === 0"></loader>
    </v-card-text>
  </v-card>
</template>

<script>
import clone from 'clone'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        statistics: 'Statistics'
      },
      statistics: []
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    hasStats() {
      if (this.quoteParam.statistics && this.quoteParam.statistics.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'statistics': {
      handler: function (values) {
        this.$emit('input', values)
      },
      deep: true,
      immediate: true
    },
    'quoteParam.statisticsInit': function (value) {
      // If its a review, when onload, init will still be at 0.
      // we will need to wait till the init status to be at 1 to slot in local state
      if (value === 1) {
        this.initStats()
      }
    }
  },
  methods: {
    doInit() {
      if (this.quoteParam.statisticsInit !== 1) {
        // Have to reload if it has not been loaded (review purpose)
        this.doGetStats()
      } else {
        this.initStats()
      }
    },
    initStats() {
      this.statistics = []
      if (this.globalForm.statistics && this.globalForm.statistics.length > 0) {
        this.$set(this, 'statistics', clone(this.globalForm.statistics))
      }
    },
    doGetStats() {
      this.$store.dispatch('motorQuoteStatistics', this.globalForm.busCls)
    },
    getParamStat(key) {
      if (this.hasStats) {
        for (let paramStat of this.quoteParam.statistics) {
          if (paramStat.value === key) {
            return paramStat
          }
        }
      }
    },
    doValidate() {
      this.resetMessages()
      return this.$validator.validateAll().then(result => {
        return result
      })
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
